import { render, staticRenderFns } from "./NewsModule.vue?vue&type=template&id=6f0c4e2e&scoped=true&"
import script from "./NewsModule.vue?vue&type=script&lang=js&"
export * from "./NewsModule.vue?vue&type=script&lang=js&"
import style0 from "./NewsModule.vue?vue&type=style&index=0&id=6f0c4e2e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f0c4e2e",
  null
  
)

export default component.exports